import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AuthHandler from "../../services/common/auth-handler";

const authHandler = AuthHandler();
const FIRST_REDIRECT_KEY = 'first-redirect';
const LogoutPage = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        i18n.changeLanguage(authHandler.getLanguage());
    }, [i18n])

    useEffect(() => {
        authHandler.reset();
        window.localStorage.removeItem(FIRST_REDIRECT_KEY);
    }, [])

    return (
        <div className="height-100 d-flex flex-column justify-content-center align-items-center">
            <img
                alt="logged out"
                src={`${process.env.PUBLIC_URL}/images/done.svg`} />
            <h1 className="fw-semi-bold text-center">{t("logged_out")}</h1>
        </div>);
}

export default LogoutPage;